import { Container } from "./styles";

interface PropTabs {
    selected?: string;
    setSelected?: (value: string) => void;
    todos?: number;
    ativos?: number;
    inativos?: number;
}

export default function PlanosTabs({ selected, setSelected, todos = 0, ativos = 0, inativos = 0 }: PropTabs) {
    return (
        <Container>
            <div
                onClick={(e) => setSelected?.(e.currentTarget.id)}
                className={selected === 'todos' ? 'selected tab' : 'tab'}
                id='todos'
            >
                Todos
                <div className={selected === 'todos' ? 'selected notification' : 'notification'}>
                    {todos}
                </div>
            </div>
            <div
                onClick={(e) => setSelected?.(e.currentTarget.id)}
                className={selected === 'ativos' ? 'selected tab' : 'tab'}
                id='ativos'
            >
                Ativos
                <div className={selected === 'ativos' ? 'selected notification' : 'notification'}>
                    {ativos}
                </div>
            </div>
            <div
                onClick={(e) => setSelected?.(e.currentTarget.id)}
                className={selected === 'inativos' ? 'selected tab' : 'tab'}
                id='inativos'
            >
                Inativos
                <div className={selected === 'inativos' ? 'selected notification' : 'notification'}>
                    {inativos}
                </div>
            </div>
        </Container>
    );
}
